export default __webpack_public_path__ + "static/media/cute-cartoon-eyes-looking-left-15466.a331fbc8.svg";